export default function Footer(){
    return <footer>
        <ul>
                    <li><a className="icon" href=""><i className="fab fa-instagram"></i></a></li>
                    <li><a className="icon" href=""><i className="fab fa-linkedin"></i></a></li>
                    <li><a className="icon" href=""><i className="fab fa-github"></i></a></li>
                </ul>
                <p><b>built by Amanda O. Nwadukwe</b></p>
    </footer>
}